(function () {
    'use strict';

    angular
        .module('app.iCal')
        .controller('ICalDetailsController', ICalDetailsController);

    ICalDetailsController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice', '$interval', '$sce'
    ];

    function ICalDetailsController($state, $stateParams, $window, bsDialog, common, dataservice, $interval, $sce) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;

        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;

        vm.opsIncludeVersion = common.opsIncludeVersion;
        vm.showBuildings = false;

        vm.viewChanged = viewChanged;
        vm.roomViewLabel = 'View';
        vm.isLoading = true;

        vm.eventTypeLabel = "Event Types";

        vm.buildingsLabel = "Views";


        activate();

        function activate() {
            var promises = [initLookups(), getItem(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                vm.isLoading = false;
                if (common.userService.isMazevoApi()) {
                    vm.showBuildings = true;
                    vm.buildingsLabel = "Views";
                }
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                if (vm.licenseInfo.NumberOfDisplaysLicensed < vm.licenseInfo.NumberOfDisplaysInUse) {
                    $state.go('404');
                }

            }, function (error) { });
        }


        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("ical.list");
        }


        function viewChanged() {
            if (vm.item.ViewId !== '') {
                dataservice.getItems("api/EventDisplay/RoomsInView/" + vm.item.ViewId).then(function (response) {
                    vm.rooms = response.data;
                }, function (error) { console.log(error) });
            }
        }

        function deleteItem() {
            return bsDialog.deleteDialog('iCal Feed')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                console.log(vm.item);
                dataservice.deleteItem("api/EventDisplay/iCal/" + vm.item.UId).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '' && common.userService.userType() === "1") {
                $state.go('404');
            }
            if (val === '') {
                vm.item = {};
                vm.item.StatusIdArray = [];
                vm.item.EventTypeIdArray = [];


                return vm.item;
            }

            return dataservice.getItem("api/EventDisplay/iCal/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;

                        if (!vm.item.StatusIdArray) {
                            vm.item.StatusIdArray = [];
                        }
                        if (!vm.item.EventTypeIdArray) {
                            vm.item.EventTypeIdArray = [];
                        }

                        viewChanged();

                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function initLookups() {
            dataservice.getItems("api/EventDisplay/GetLookups").then(function (response) {
                vm.statuses = response.data.Statuses;
                vm.eventTypes = response.data.EventTypes;
                vm.views = response.data.Views;
                vm.buildings = response.data.Buildings;


            }, function (error) { console.log(error) });


        }

        function save() {
            if (vm.item.StatusIdArray.length === 0) {
                common.logger.error("You must select at least one status");
                return;
            }
            if (vm.item.EventTypeIdArray.length === 0 && common.userService.apiTypeId() !== common.config.apiTypes.collegeNet) {
                common.logger.error("You must select at least one event type");
                return;
            }

            vm.isSaving = true;
            vm.item.MainBackgroundImage = "";

            dataservice.saveItem('api/EventDisplay/iCal/', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });

        }
    }

})();
